import { formatInTimeZone } from "date-fns-tz"

export function uniqFromArray<T extends object>(a: T[], param: keyof T): T[] {
  return a.filter(function (item, pos, array) {
    return array.map((mapItem) => mapItem[param]).indexOf(item[param]) === pos
  })
}

export function areWeTestingWithVite(): boolean {
  return !!process.env.VITEST_WORKER_ID || process.env.VITEST === "true"
}

export const sleep = (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}

// question: what should normalizing a skill name entail?
// export const normalizeSkillName = (skillName: string) => skillName.trim().toLocaleLowerCase()
export const normalizeSkillName = (skillName: string) => skillName.trim()

export const getFormattedDateInTimeZone = (date: Date | string, timeZone?: string) => {
  return formatInTimeZone(date, timeZone || "UTC", "MM/dd/yy 'at' hh:mm aaaaa'm' zzz")
}
